var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.containerClass,attrs:{"fluid":""}},[_c('invoice-form',{attrs:{"mode":"edit","invoice":_vm.invoice.data},on:{"cancel":_vm.onCancel},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('invoice-detail-header',{attrs:{"invoice":_vm.invoice.data}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }